import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"

export const DialogStyles = makeStyles((theme: Theme) => createStyles({
	dialog: {
	},
	dialogroot: {
		'& h2': {
			display: "flex",
			justifyContent: "space-between",
			fontSize: theme.typography.h6.fontSize,
			color: theme.palette.common.black,
		}
	},
	dialogicon: {
		color: theme.palette.primary.main,
	},
	dialogTitle: {
		fontSize: 22,
		color: "rgba(0, 0, 0, 0.87) !important"
	},
	dialogPaper: {
		width: "100%",
	},
	dialogpaperScrollPaper: {
		width: "100%",
		borderRadius: "4px !important",
	},
	dialogPaperScrollBody: {

	},
	navarrows: {
		display: "flex",
		justifyContent: "space-between"
	},
	navleft: {
		cursor: "pointer"
	},
	navright: {
		cursor: "pointer"
	},
	dialogActions: {
		padding: "8px 16px",
		borderTop: `1px solid ${theme.palette.divider}`,
		"& button": {
			border: `1px solid ${theme.palette.primary.main}`,
			fontFamily: theme.typography.secondaryFontFamily,
			padding: "10px 8px",
			fontSize: theme.typography.subtitle2.fontSize,
			lineHeight: 1,
			borderRadius: 4,
		}
	},
	dialogContent: {
		fontSize: theme.typography.body2.fontSize,
		color: "rgba(0, 0, 0, 0.87)",
	},
	dialogCnt: {
		paddingTop: 0,
		paddingBottom: 0,
	},
	dialogFull: {
		paddingLeft: 0,
		paddingRight: 0
	},
	modalHeight: {
		width: "100%",
		height: '50vh',
		[theme.breakpoints.up(420)]: {
			height: "auto",
			float: "left",
			paddingBottom: 10
		}
	}
}));